import React from "react";
import PropTypes from "prop-types";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useSpring, animated } from "@react-spring/web";
import ProfileItems from "./ProfileItems";
import { useTheme } from "@emotion/react";
import useDeviceType from "./Hooks/useDeviceType";
const Fade = React.forwardRef(function Fade(props, ref) {
  const {
    children,
    in: open,
    onClick,
    onEnter,
    onExited,
    ownerState,
    ...other
  } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter(null, true);
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited(null, true);
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {React.cloneElement(children, { onClick })}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element.isRequired,
  in: PropTypes.bool,
  onClick: PropTypes.any,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
  ownerState: PropTypes.any,
};

function ProfileSetting({ setSettingModal, settingModal }) {
    const device = useDeviceType()
  const handleClose = () => setSettingModal(false);
  const theme = useTheme().palette.mode;
  const style = {
    position: "absolute",
    width:device==="mobile"?"100%": "60%",
    top: "50%",
    left: "50%",
    background: theme === "dark" ? "#161B25" : "#F7FBFF",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
    borderRadius: "16px",
    boxShadow:
      "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)",
    padding: "2rem 1em",
  };
  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={settingModal}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          TransitionComponent: Fade,
        },
      }}
    >
      <Fade in={settingModal}>
      <Box sx={style}>
          <Button sx={{display:'flex' ,justifyContent:'center', margin:'0 0 0 auto'}}onClick={handleClose} >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              
            >
              <path
                d="M8 8L16 16"
                stroke="red"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 8L8 16"
                stroke="red"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
          <ProfileItems />
        </Box>
      </Fade>
    </Modal>
  );
}

export default ProfileSetting;
